interface HamburgerMenuProps {
  onClick: () => void;
  isActive: boolean;
}

const HamburgerMenu = ({ onClick, isActive }: HamburgerMenuProps) => {
  return (
    <div
      className="flex w-6 h-6 rounded-4 cursor-pointer hover:bg-gray-200 active:bg-gray-400 transition-[background] duration-200 relative select-none items-center justify-center"
      onClick={onClick}
      data-sidebar-toggle
    >
      <span className="relative w-[18px] h-3">
        {/* Top line */}
        <span
          className="absolute left-0 w-[18px] h-0.5 bg-[#111] transition-all duration-200 ease-in-out origin-center"
          style={{
            top: isActive ? "5px" : "0px",
            transform: isActive ? "rotate(45deg)" : "rotate(0deg)",
          }}
        />
        {/* Middle line */}
        <span
          className="absolute top-[5px] left-0 w-[18px] h-0.5 bg-[#111] transition-opacity duration-200 ease-in-out"
          style={{ opacity: isActive ? 0 : 1 }}
        />
        {/* Bottom line */}
        <span
          className="absolute left-0 w-[18px] h-0.5 bg-[#111] transition-all duration-200 ease-in-out origin-center"
          style={{
            bottom: isActive ? "5px" : "0px",
            transform: isActive ? "rotate(-45deg)" : "rotate(0deg)",
          }}
        />
      </span>
    </div>
  );
};

export default HamburgerMenu;
